import { useDispatch, useSelector } from "react-redux";
import EODBODScreen from "../../../components/patient/EOD-BOD-Screen/EODBODScreen";
import { useEffect, useState } from "react";
import { AppDispatch, RootState } from "../../../store/store";
import { fetchAllSchemesOnBoard } from "../../../models/schemeSlice";
import { errorMessage } from "../../../utils/notificationUtils";

const EODBODScreenContainer = () => {
  const { hospital, auth, scheme } = useSelector((state: RootState) => state);
  const [selectedHospital, setSelectedHospital] = useState<number | null>(hospital?.selectedHospital?.value || -1);
  const [selectedScheme, setSelectedScheme] = useState<number | null>(null);
  
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (selectedHospital) {
      dispatch(
        fetchAllSchemesOnBoard({
          accessToken: auth.accessToken || "",
          healthCareId: selectedHospital,
        }),
      );
    }
  }, [selectedHospital, auth.accessToken, dispatch]);

  useEffect(() => {
    if (!selectedHospital || selectedHospital <= 0) {
      errorMessage("Please select another hospital");
    }
    setSelectedScheme(null);
  }, [selectedHospital]);

  return (
    <div>
      <EODBODScreen
        availableHospitals={hospital.availableHospitals}
        selectedHospital={selectedHospital}
        setSelectedHospital={setSelectedHospital}
        availableSchemes={scheme?.schemeOnBoarding}
        selectedScheme={selectedScheme}
        setSelectedScheme={setSelectedScheme}
      />
    </div>
  );
};

export default EODBODScreenContainer;
